/**
 * Constants for UI Parkmobile components
 */

// Image optimization settings
export const IMAGE_QUALITY = 80;